function t(...o) {
  let n = [];
  for (let e of o)
    e != null && typeof e != "boolean" && typeof e == "string" && n.push(e);
  return n.join(" ");
}
export {
  t as clsx
};
